module.exports = __webpack_public_path__ + "static/media/S1N12-3.8773315f.svg";